/* Video play pause */
document.addEventListener("DOMContentLoaded", function () {
  const pauseSVG = `
    <div class="custom-pause-btn">
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="32" cy="32" r="32" fill="#0E1E26" fill-opacity="0.25"/>
        <g clip-path="url(#clip0_502_331)">
          <path d="M40.25 24.5V39.5C40.25 39.8978 40.092 40.2794 39.8107 40.5607C39.5294 40.842 39.1478 41 38.75 41H35C34.6022 41 34.2206 40.842 33.9393 40.5607C33.658 40.2794 33.5 39.8978 33.5 39.5V24.5C33.5 24.1022 33.658 23.7206 33.9393 23.4393C34.2206 23.158 34.6022 23 35 23H38.75C39.1478 23 39.5294 23.158 39.8107 23.4393C40.092 23.7206 40.25 24.1022 40.25 24.5ZM29 23H25.25C24.8522 23 24.4706 23.158 24.1893 23.4393C23.908 23.7206 23.75 24.1022 23.75 24.5V39.5C23.75 39.8978 23.908 40.2794 24.1893 40.5607C24.4706 40.842 24.8522 41 25.25 41H29C29.3978 41 29.7794 40.842 30.0607 40.5607C30.342 40.2794 30.5 39.8978 30.5 39.5V24.5C30.5 24.1022 30.342 23.7206 30.0607 23.4393C29.7794 23.158 29.3978 23 29 23Z" fill="white"/>
        </g>
        <defs>
          <clipPath id="clip0_502_331">
            <rect width="24" height="24" fill="white" transform="translate(20 20)"/>
          </clipPath>
        </defs>
      </svg>
    </div>
  `;

  function attachPauseIcon(mediaElement) {
    if (!mediaElement) return;
    const video = mediaElement.querySelector("video");
    if (!video) return;
    if (mediaElement.querySelector(".custom-pause-btn")) return;

    mediaElement.style.position = "relative";
    mediaElement.style.pointerEvents = "auto";
    mediaElement.insertAdjacentHTML("beforeend", pauseSVG);

    const pauseButton = mediaElement.querySelector(".custom-pause-btn");

    pauseButton.addEventListener("click", function (e) {
      e.stopPropagation();
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });
  }

  const observer = new MutationObserver(() => {
    document.querySelectorAll("deferred-media").forEach((media) => {
      attachPauseIcon(media);
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  document.querySelectorAll("deferred-media").forEach((media) => {
    attachPauseIcon(media);
  });
});

/* Video ebook animation */
document.addEventListener("DOMContentLoaded", () => {
  const target = document.querySelector('.video-text-ebook');
  if (!target) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        target.classList.add('visible');
        observer.disconnect();
      }
    });
  }, {
    threshold: 0.2,
  });

  observer.observe(target);
});

/* Delivery date in product page */
document.addEventListener("DOMContentLoaded", function () {
  const target = document.querySelector(".estimated-delivery p strong");
  if (!target) return;

  const body = document.body;
  const market = body.dataset.marketHandle;
  const mapString = body.dataset.shippingMap;

  let shippingDays = 7;

  if (mapString) {
    const pairs = mapString.split(",");

    for (let pair of pairs) {
      const [handle, days] = pair.split("-").map(s => s.trim());

      if (handle === market) {
        shippingDays = parseInt(days, 10);
        break;
      }
    }
  }

  const date = new Date();
  date.setDate(date.getDate() + shippingDays);

  const formatted = date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
  });

  target.textContent = formatted;
});

/* Delivery price in terms pages */
document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".page-width-content");
  if (!container) return;

  const marketHandle = document.body.dataset.marketHandle;
  const map = document.body.dataset.shippingPriceMap;

  if (!marketHandle || !map) return;

  let price = null;
  let fallback = null;

  map.split(",").forEach(pair => {
    const [handle, value] = pair.split(":").map(s => s.trim());

    if (handle === "default") fallback = value;
    if (handle === marketHandle) price = value;
  });

  price = price || fallback;
  if (!price) return;

  const cents = parseInt(price, 10);
  if (isNaN(cents)) return;

  let formatted = cents;

  if (window.Shopify && Shopify.formatMoney) {
    formatted = Shopify.formatMoney(cents);
  }

  container.innerHTML = container.innerHTML.replace(/\{shipping_price\}/g, formatted);
});

/* Custom scrollbar in collection page */
document.querySelectorAll('.matsato-collections').forEach(section => {
  const grid = section.querySelector('.matsato-collections-grid');
  const thumb = section.querySelector('.matsato-scrollbar-thumb');

  if (!grid || !thumb) return;

  const updateThumb = () => {
    const scrollRatio =
      grid.scrollLeft / (grid.scrollWidth - grid.clientWidth);

    const thumbWidth = Math.max(
      (grid.clientWidth / grid.scrollWidth) * grid.clientWidth,
      30
    );

    thumb.style.width = `${thumbWidth}px`;
    thumb.style.left = `${scrollRatio * (grid.clientWidth - thumbWidth)}px`;
  };

  grid.addEventListener('scroll', updateThumb);
  window.addEventListener('resize', updateThumb);

  updateThumb();
});

/* Judgeme rework */
(function () {
  function insert(summary) {
    if (!(summary instanceof HTMLElement)) return;

    var widget = summary.closest('.jdgm-rev-widg[data-average-rating]');
    if (!widget) return;

    var rating = widget.getAttribute('data-average-rating');
    if (!rating) return;

    var inner = summary.querySelector('.jdgm-rev-widg__summary-inner');
    if (!inner) return;

    if (inner.querySelector(':scope > .jdgm-custom-average-rating')) return;

    var el = document.createElement('span');
    el.className = 'jdgm-custom-average-rating';
    el.textContent = rating;

    inner.insertBefore(el, inner.firstChild);
    summary.dataset.jdgmRatingInjected = 'true';
  }

  function scan(root) {
    root.querySelectorAll('.jdgm-rev-widg__summary').forEach(insert);
  }

  function observe(root) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches('.jdgm-rev-widg__summary')) insert(node);
          node.querySelectorAll?.('.jdgm-rev-widg__summary').forEach(insert);
        });
      });
    }).observe(root, { childList: true, subtree: true });
  }

  var tries = 0;
  var wait = setInterval(function () {
    var section = document.querySelector('.reviews-section');
    if (!section) {
      if (++tries > 30) clearInterval(wait);
      return;
    }

    scan(section);
    observe(section);
    clearInterval(wait);
  }, 200);
})();

(function() {
  function addCount(row) {
    if (row.dataset.jdgmCountInjected === 'true') return;
    var count = row.querySelectorAll('.jdgm-star.jdgm--on').length;
    var span = document.createElement('span');
    span.className = 'jdgm-histogram-count';
    span.textContent = count;
    row.insertBefore(span, row.firstChild);
    row.dataset.jdgmCountInjected = 'true';
  }

  function scan(widget) {
    widget.querySelectorAll('.jdgm-histogram__row').forEach(addCount);
  }

  function observe(widget) {
    new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches('.jdgm-histogram__row')) addCount(node);
          node.querySelectorAll?.('.jdgm-histogram__row').forEach(addCount);
        });
      });
    }).observe(widget, { childList: true, subtree: true });
  }

  var interval = setInterval(function() {
    var widget = document.querySelector('.jdgm-review-widget');
    if (!widget) return;
    scan(widget);
    observe(widget);
    clearInterval(interval);
  }, 200);
})();

(function() {
  function inject(wrapper) {
    if (wrapper.dataset.jdgmSortInjected === 'true') return;
    var textEl = wrapper.querySelector('.reviews-translations.sort') 
      || document.querySelector('.reviews-translations.sort');
    if (!textEl) return;

    var svg = '<svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.85156 6.95736L10.1016 10.3496L13.3516 6.95736M6.85156 3.65348L3.60156 0.349609M3.60156 0.349609L0.351562 3.65101M3.60156 0.349609V10.2612M10.1016 0.349609V10.2612" stroke="#0E1E26" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    var span = document.createElement('span');
    span.className = 'jdgm-custom-sort-label';
    span.innerHTML = svg + textEl.textContent.trim();

    wrapper.insertBefore(span, wrapper.firstChild);
    wrapper.dataset.jdgmSortInjected = 'true';
  }

  function scan(widget) {
    widget.querySelectorAll('.jdgm-sort-dropdown-wrapper').forEach(inject);
  }

  function observe(widget) {
    new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches('.jdgm-sort-dropdown-wrapper')) inject(node);
          node.querySelectorAll?.('.jdgm-sort-dropdown-wrapper').forEach(inject);
        });
      });
    }).observe(widget, { childList: true, subtree: true });
  }

  var interval = setInterval(function() {
    var widget = document.querySelector('.jdgm-review-widget');
    if (!widget) return;
    scan(widget);
    observe(widget);
    clearInterval(interval);
  }, 200);
})();

(function() {
  function inject(rowActions) {
    if (rowActions.dataset.jdgmReviewsInjected === 'true') return;
    var widget = rowActions.closest('.jdgm-rev-widg[data-number-of-reviews]');
    if (!widget) return;

    var count = widget.getAttribute('data-number-of-reviews');
    if (!count) return;

    var txt = document.querySelector('.reviews-translations.reviews');
    if (!txt) return;

    var label = txt.textContent.trim();
    var cap = label.charAt(0).toUpperCase() + label.slice(1);

    var span = document.createElement('span');
    span.className = 'jdgm-custom-reviews-label';
    span.textContent = count + ' ' + cap;

    rowActions.insertBefore(span, rowActions.firstChild);
    rowActions.dataset.jdgmReviewsInjected = 'true';
  }

  function scan(widget) {
    widget.querySelectorAll('.jdgm-row-actions').forEach(inject);
  }

  function observe(widget) {
    new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches('.jdgm-row-actions')) inject(node);
          node.querySelectorAll?.('.jdgm-row-actions').forEach(inject);
        });
      });
    }).observe(widget, { childList: true, subtree: true });
  }

  var interval = setInterval(function() {
    var widget = document.querySelector('.jdgm-review-widget');
    if (!widget) return;
    scan(widget);
    observe(widget);
    clearInterval(interval);
  }, 200);
})();

(function() {
  var svg = '<svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.84812 13.802C5.06333 13.9316 5.30979 14 5.56096 14C5.81212 14 6.05858 13.9316 6.27377 13.802C7.74898 12.9112 8.96992 11.6555 9.81898 10.1559C10.6681 8.6562 11.1167 6.96323 11.1217 5.23992V3.05638C11.1225 2.77918 11.0398 2.50815 10.8844 2.27863C10.729 2.0491 10.508 1.87174 10.2503 1.76967L6.07522 0.0996398C5.74513 -0.0332133 5.37637 -0.0332133 5.04626 0.0996398L0.871399 1.76967C0.61367 1.87174 0.392682 2.0491 0.237243 2.27863C0.0818117 2.50815 -0.000867338 2.77918 6.86147e-06 3.05638V5.23992C0.00495786 6.96326 0.453607 8.65629 1.30274 10.1559C2.15187 11.6555 3.37286 12.9112 4.84812 13.802ZM2.67127 6.57374L4.51744 8.41992L8.45078 4.48655L8.93419 4.97004L4.75916 9.14508C4.69504 9.20914 4.6081 9.24511 4.51744 9.24511C4.42678 9.24511 4.33984 9.20914 4.27573 9.14508L2.18785 7.05717L2.67127 6.57374Z" fill="#CF5123"/></svg>';

  function processReview(review) {
    if (review.dataset.jdgmAuthorProcessed === 'true') return;

    var author = review.querySelector('.jdgm-rev__author');
    var content = review.querySelector('.jdgm-rev__content');
    var body = review.querySelector('.jdgm-rev__body');
    if (!author || !content) return;

    if (body) {
      body.insertAdjacentElement('afterend', author);
    } else {
      content.appendChild(author);
    }

    var verifiedSource = document.querySelector('.reviews-translations.verified');
    if (verifiedSource) {
      var text = verifiedSource.textContent.trim();
      if (text) {
        var verifiedLine = document.createElement('div');
        verifiedLine.className = 'jdgm-rev__verified';
        verifiedLine.innerHTML = svg + text;
        author.insertAdjacentElement('afterend', verifiedLine);
      }
    }

    review.dataset.jdgmAuthorProcessed = 'true';
  }

  function scan(widget) {
    widget.querySelectorAll('.jdgm-rev').forEach(processReview);
  }

  function observe(widget) {
    new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches('.jdgm-rev')) processReview(node);
          node.querySelectorAll?.('.jdgm-rev').forEach(processReview);
        });
      });
    }).observe(widget, { childList: true, subtree: true });
  }

  var interval = setInterval(function() {
    var widget = document.querySelector('.jdgm-review-widget');
    if (!widget) return;
    scan(widget);
    observe(widget);
    clearInterval(interval);
  }, 200);
})();

/* Move elements in all products page */
document.addEventListener('DOMContentLoaded', function () {
  var contents = document.querySelectorAll(
    '.template-all-products .section-resource-list__content, .template-list-collections .section-resource-list__content'
  );

  if (!contents.length) return;

  contents.forEach(function (content) {
    var resourceList = content.previousElementSibling;

    while (resourceList && !resourceList.classList.contains('resource-list')) {
      resourceList = resourceList.previousElementSibling;
    }

    if (resourceList) {
      resourceList.appendChild(content);
    }
  });
});

/* Add price to add to cart */
(() => {
  const BTN_SELECTOR = '.product-details .add-to-cart-text';
  const PRICE_SELECTOR = 'product-price .price';

  const update = () => {
    const btn = document.querySelector(BTN_SELECTOR);
    const priceEl = document.querySelector(PRICE_SELECTOR);
    if (!btn || !priceEl) return;

    const price = priceEl.textContent.trim();
    if (!price) return;

    const baseText =
      btn.dataset.baseText || btn.textContent.split('•')[0].trim();

    btn.dataset.baseText = baseText;
    btn.textContent = `${baseText} • ${price}`;
  };

  const waitForPrice = () => {
    const priceEl = document.querySelector(PRICE_SELECTOR);
    if (!priceEl) {
      requestAnimationFrame(waitForPrice);
      return;
    }

    update();

    const observer = new MutationObserver(update);
    observer.observe(priceEl, {
      characterData: true,
      childList: true,
      subtree: true
    });
  };

  waitForPrice();
})();

/* Sticky ATC */
(() => {
  const STICKY_BAR_ID = "sticky-atc";
  const STICKY_SLOT_ID = "sticky-atc-button-slot";
  const STICKY_PRICE_SLOT_ID = "sticky-atc-price-slot";
  const SHOW_AFTER_PX = 1000;

  const MAIN_BUTTON_SELECTOR =
    'button[id^="BuyButtons-ProductSubmitButton-"][name="add"][type="submit"]';

  const PRICE_CONTAINER_SELECTOR = 'product-price [ref="priceContainer"]';

  const getBar = () => document.getElementById(STICKY_BAR_ID);
  const getSlot = () => document.getElementById(STICKY_SLOT_ID);
  const getPriceSlot = () => document.getElementById(STICKY_PRICE_SLOT_ID);

  const getScrollTop = () =>
    document.scrollingElement?.scrollTop ?? window.pageYOffset ?? 0;

  const setVisible = (visible) => {
    const bar = getBar();
    if (!bar) return;
    bar.classList.toggle("is-visible", visible);
    bar.setAttribute("aria-hidden", visible ? "false" : "true");
  };

  const isFooterVisible = () => {
    const footer = document.querySelector("footer, .shopify-section-group-footer-group");
    if (!footer) return false;

    const rect = footer.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  };

  const onScroll = () => {
    const shouldShow = getScrollTop() >= SHOW_AFTER_PX && !isFooterVisible();
    setVisible(shouldShow);
  };

  const findMainBtn = () => document.querySelector(MAIN_BUTTON_SELECTOR);
  const findMainForm = (btn) => btn?.closest('form[action*="/cart/add"]') || null;

  const findPriceContainer = () => document.querySelector(PRICE_CONTAINER_SELECTOR);

  const syncButton = (mainBtn, stickyBtn) => {
    const disabled = mainBtn.disabled || mainBtn.getAttribute("aria-disabled") === "true";
    stickyBtn.disabled = disabled;
    stickyBtn.setAttribute("aria-disabled", disabled ? "true" : "false");
    stickyBtn.className = mainBtn.className;
    stickyBtn.innerHTML = mainBtn.innerHTML;
  };

  const syncPrice = () => {
    const priceSlot = getPriceSlot();
    const priceContainer = findPriceContainer();
    if (!priceSlot || !priceContainer) return;

    const next = priceContainer.innerHTML;
    if (priceSlot.innerHTML !== next) priceSlot.innerHTML = next;
  };

  const mountButton = () => {
    const slot = getSlot();
    if (!slot) return;

    const mainBtn = findMainBtn();
    if (!mainBtn) return;

    let stickyBtn = slot.querySelector("[data-sticky-atc]");
    if (!stickyBtn) {
      slot.innerHTML = "";
      stickyBtn = mainBtn.cloneNode(true);
      if (stickyBtn.id) stickyBtn.id = `${stickyBtn.id}--sticky`;
      stickyBtn.dataset.stickyAtc = "1";

      stickyBtn.addEventListener(
        "click",
        (e) => {
          e.preventDefault();
          e.stopPropagation();

          const btn = findMainBtn();
          if (!btn) return;

          const disabled = btn.disabled || btn.getAttribute("aria-disabled") === "true";
          if (disabled) return;

          const form = findMainForm(btn);
          if (form?.requestSubmit) form.requestSubmit(btn);
          else btn.click();
        },
        true
      );

      slot.appendChild(stickyBtn);
    }

    syncButton(mainBtn, stickyBtn);
  };

  const observeLivePrice = () => {
    let observedNode = null;
    let mo = null;

    const bind = () => {
      const priceContainer = findPriceContainer();
      if (!priceContainer || priceContainer === observedNode) return;

      observedNode = priceContainer;

      if (mo) mo.disconnect();
      mo = new MutationObserver(() => syncPrice());
      mo.observe(priceContainer, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true
      });

      syncPrice();
    };

    bind();

    const bodyMo = new MutationObserver(() => {
      bind();
      syncPrice();
    });
    bodyMo.observe(document.body, { childList: true, subtree: true });
  };

  const observeLiveButton = () => {
    let observedBtn = null;
    let btnMo = null;

    const bind = () => {
      const slot = getSlot();
      const stickyBtn = slot?.querySelector("[data-sticky-atc]");
      const mainBtn = findMainBtn();
      if (!slot || !stickyBtn || !mainBtn) return;

      if (mainBtn !== observedBtn) {
        observedBtn = mainBtn;

        if (btnMo) btnMo.disconnect();
        btnMo = new MutationObserver(() => {
          const currentSticky = getSlot()?.querySelector("[data-sticky-atc]");
          const currentMain = findMainBtn();
          if (!currentSticky || !currentMain) return;
          syncButton(currentMain, currentSticky);
        });

        btnMo.observe(mainBtn, {
          attributes: true,
          childList: true,
          subtree: true,
          characterData: true
        });

        syncButton(mainBtn, stickyBtn);
      }
    };

    bind();

    const bodyMo = new MutationObserver(bind);
    bodyMo.observe(document.body, { childList: true, subtree: true });
  };

  const init = () => {
    onScroll();
    mountButton();
    syncPrice();

    observeLivePrice();
    observeLiveButton();

    window.addEventListener("scroll", onScroll, { passive: true });

    window.addEventListener("pageshow", () => {
      onScroll();
      mountButton();
      syncPrice();
    });

    document.addEventListener(
      "change",
      (e) => {
        if (e.target?.name === "id" || e.target?.closest("variant-radios, variant-selects")) {
          setTimeout(() => {
            mountButton();
            syncPrice();
          }, 0);
        }
      },
      true
    );

    let tries = 0;
    const t = setInterval(() => {
      tries += 1;
      onScroll();
      mountButton();
      syncPrice();
      if ((findMainBtn() && findPriceContainer()) || tries > 60) clearInterval(t);
    }, 200);
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();

/* Free gift */
(() => {
  const GIFT_HANDLE = "matsato-recipe-book";
  const CART_RE = /\/cart(\/add|\/change|\/update|\/clear|\.js|\?|$)/i;

  let running = false;
  let pending = false;
  let lastSig = "";
  let giftVariantId = null;
  let giftVariantIdPromise = null;
  let lastUiPatchAt = 0;

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  function urlOf(input) {
    return typeof input === "string" ? input : input?.url || "";
  }

  function isCartUrl(url) {
    return typeof url === "string" && CART_RE.test(url);
  }

  function cartSig(cart) {
    if (!cart) return "null";
    const items = (cart.items || [])
      .map((i) => `${i.id}:${i.quantity}:${i.handle}`)
      .sort()
      .join("|");
    return `${cart.item_count || 0}::${items}`;
  }

  async function getCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin", cache: "no-store" });
    return res.ok ? res.json() : null;
  }

  function getGiftVariantId() {
    if (giftVariantId) return Promise.resolve(giftVariantId);
    if (giftVariantIdPromise) return giftVariantIdPromise;

    giftVariantIdPromise = fetch(`/products/${GIFT_HANDLE}.js`, {
      credentials: "same-origin",
      cache: "no-store",
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((p) => {
        const v = p?.variants?.find((x) => x.available) || p?.variants?.[0];
        giftVariantId = v?.id || null;
        return giftVariantId;
      })
      .catch(() => null);

    return giftVariantIdPromise;
  }

  async function updateCart(updates) {
    const res = await fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates }),
    });
    return res.ok;
  }

  async function clampGiftBody(url, init) {
    if (!init || typeof init.body !== "string") return init;
    if (!/\/cart\/(change|update)\.js/i.test(url)) return init;

    const giftId = await getGiftVariantId();
    if (!giftId) return init;

    try {
      const body = JSON.parse(init.body);

      if (/\/cart\/change\.js/i.test(url) && body.id == giftId && Number(body.quantity) > 1) {
        body.quantity = 1;
        return { ...init, body: JSON.stringify(body) };
      }

      if (body.updates && giftId in body.updates && Number(body.updates[giftId]) > 1) {
        body.updates[giftId] = 1;
        return { ...init, body: JSON.stringify(body) };
      }
    } catch (_) {}

    return init;
  }

  function findHeaderSectionCandidates() {
    const out = new Set();

    const direct = ["shopify-section-header_section", "shopify-section-header"];
    for (const id of direct) {
      const el = document.getElementById(id);
      if (el) out.add(id.replace("shopify-section-", ""));
    }

    const sectionEls = Array.from(document.querySelectorAll("[id^='shopify-section-']"));
    for (const el of sectionEls) {
      const id = el.id || "";
      if (!id.startsWith("shopify-section-")) continue;
      const handle = id.replace("shopify-section-", "");
      if (/header/i.test(handle)) out.add(handle);
    }

    out.add("header_section");
    out.add("header");

    return Array.from(out);
  }

  async function fetchSection(handle) {
    const res = await fetch(`/?sections=${encodeURIComponent(handle)}`, {
      credentials: "same-origin",
      cache: "no-store",
    });
    if (!res.ok) return { ok: false, handle, html: null };
    const json = await res.json();
    const html = json?.[handle] || null;
    return { ok: !!html, handle, html };
  }

  function patchBubbleAndIconFromSection(tmp) {
    const sel = {
      bubbleWrap: ".cart-bubble",
      bubbleText: ".cart-bubble__text",
      bubbleCount: ".cart-bubble__text-count,[data-testid='cart-bubble']",
      cartIcon: "cart-icon",
    };

    const incWrap = tmp.querySelector(sel.bubbleWrap);
    const curWrap = document.querySelector(sel.bubbleWrap);

    const incText = tmp.querySelector(sel.bubbleText);
    const curText = document.querySelector(sel.bubbleText);

    const incCount = tmp.querySelector(sel.bubbleCount);
    const curCount = document.querySelector(sel.bubbleCount);

    const incIcon = tmp.querySelector(sel.cartIcon);
    const curIcon = document.querySelector(sel.cartIcon);

    if (incCount && curCount) {
      curCount.textContent = incCount.textContent;
      curCount.className = incCount.className;
      for (const a of ["aria-hidden", "hidden"]) {
        if (incCount.hasAttribute(a)) curCount.setAttribute(a, incCount.getAttribute(a) || "");
        else curCount.removeAttribute(a);
      }
    }

    if (incText && curText) {
      curText.className = incText.className;
      for (const a of ["aria-hidden", "hidden"]) {
        if (incText.hasAttribute(a)) curText.setAttribute(a, incText.getAttribute(a) || "");
        else curText.removeAttribute(a);
      }
      const incVH = incText.querySelector(".visually-hidden");
      const curVH = curText.querySelector(".visually-hidden");
      if (incVH && curVH) curVH.textContent = incVH.textContent;
    }

    if (incWrap && curWrap) {
      curWrap.className = incWrap.className;
      for (const a of ["aria-hidden", "hidden"]) {
        if (incWrap.hasAttribute(a)) curWrap.setAttribute(a, incWrap.getAttribute(a) || "");
        else curWrap.removeAttribute(a);
      }
    }

    if (incIcon && curIcon) {
      curIcon.className = incIcon.className;
    }
  }

  async function patchDrawerUI() {
    const t = Date.now();
    if (t - lastUiPatchAt < 200) return false;
    lastUiPatchAt = t;

    const candidates = findHeaderSectionCandidates();
    for (const handle of candidates) {
      const got = await fetchSection(handle);
      if (!got.ok || !got.html) continue;

      const tmp = document.createElement("div");
      tmp.innerHTML = got.html;

      const incomingItems = tmp.querySelector("cart-items-component");
      const currentItems = document.querySelector("cart-items-component");

      let did = false;

      if (incomingItems && currentItems) {
        currentItems.innerHTML = incomingItems.innerHTML;
        did = true;
      }

      patchBubbleAndIconFromSection(tmp);

      if (did) return true;

      const incomingDrawer = tmp.querySelector("cart-drawer-component");
      const currentDrawer = document.querySelector("cart-drawer-component");
      if (incomingDrawer && currentDrawer) {
        currentDrawer.replaceWith(incomingDrawer);
        return true;
      }
    }

    return false;
  }

  async function reconcile(cart) {
    if (!cart) return;

    const sig = cartSig(cart);
    if (sig === lastSig) return;
    lastSig = sig;

    if (running) {
      pending = true;
      return;
    }

    running = true;
    try {
      const giftId = await getGiftVariantId();
      if (!giftId) return;

      const items = Array.isArray(cart.items) ? cart.items : [];
      const giftLine = items.find((i) => i.handle === GIFT_HANDLE);
      const nonGiftQty = items
        .filter((i) => i.handle !== GIFT_HANDLE)
        .reduce((s, i) => s + (Number(i.quantity) || 0), 0);

      const shouldHaveGift = nonGiftQty > 0;
      const hasGift = !!giftLine;
      const giftQty = giftLine ? Number(giftLine.quantity) || 0 : 0;

      let changed = false;

      if (shouldHaveGift) {
        if (!hasGift || giftQty !== 1) changed = await updateCart({ [giftId]: 1 });
      } else {
        if (hasGift) changed = await updateCart({ [giftId]: 0 });
      }

      if (changed) {
        await sleep(150);
        const cart2 = await getCart();
        if (cart2) lastSig = cartSig(cart2);
        await patchDrawerUI();
      }
    } finally {
      running = false;
      if (pending) {
        pending = false;
        const latest = await getCart();
        if (latest) await reconcile(latest);
      }
    }
  }

  const _fetch = window.fetch;
  window.fetch = async function (input, init) {
    const url = urlOf(input);
    if (isCartUrl(url)) init = await clampGiftBody(url, init);
    const res = await _fetch.apply(this, [input, init]);

    try {
      if (url.includes("/cart.js")) {
        res
          .clone()
          .json()
          .then((cart) => reconcile(cart))
          .catch(() => {});
      } else if (isCartUrl(url)) {
        setTimeout(() => {
          getCart()
            .then((cart) => cart && reconcile(cart))
            .catch(() => {});
        }, 350);
      }
    } catch (_) {}

    return res;
  };

  const _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__isCart = isCartUrl(url);
    this.__isCartJs = typeof url === "string" && url.includes("/cart.js");
    return _open.apply(this, arguments);
  };

  const _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__isCart) {
      this.addEventListener(
        "loadend",
        () => {
          try {
            if (this.__isCartJs) {
              const cart = JSON.parse(this.responseText || "null");
              reconcile(cart).catch?.(() => {});
            } else {
              setTimeout(() => {
                getCart()
                  .then((cart) => cart && reconcile(cart))
                  .catch(() => {});
              }, 350);
            }
          } catch (_) {}
        },
        { once: true }
      );
    }
    return _send.apply(this, arguments);
  };

  document.addEventListener("dialog:open", () => {
    getCart()
      .then((cart) => cart && reconcile(cart))
      .catch(() => {});
  });

  getCart()
    .then((cart) => cart && reconcile(cart))
    .catch(() => {});
})();

/* Kaching bundles rework */
(() => {
  const ROOT_SELECTOR = '.product-information .shopify-app-block';

  const LABEL_SELECTOR = '.kaching-bundles__bar-label';
  const PRICING_SELECTOR = '.kaching-bundles__bar-pricing';

  const BUNDLES_SELECTOR = '.kaching-bundles';
  const TEXTS_SELECTOR = '.kaching-texts';

  const SELECTED_BAR_SELECTOR = '.kaching-bundles__bar.kaching-bundles__bar--selected';
  const TITLE_SELECTOR = '.kaching-bundles__bar-title';
  const TARGET_BLOCK_SELECTOR = '.kaching-texts .text-block:first-child';

  const SRC_PRICE_SELECTOR = '.kaching-bundles__bar-price';
  const SRC_COMPARE_SELECTOR = '.kaching-bundles__bar-full-price';

  const PRICE_CONTAINER_SELECTOR = 'product-price [ref="priceContainer"]';

  const DISCOUNT_BADGE_ATTR = 'data-kaching-discount-badge';
  const DISCOUNT_SIG_ATTR = 'data-kaching-discount-sig';

  const FIRST_LINE_SELECTOR = '.kaching-bundles__bar-first-line';
  const PER_SET_ATTR = 'data-kaching-per-set';

  const MOBILE_MQ = window.matchMedia('(max-width: 749px)');
  const _origParent = new WeakMap();
  const _busyRoots = new WeakSet();

  const is2pcsDesign = () => document.body.classList.contains('kaching-2pcs-bundle-design');

  const ensurePricingBreak = (bar) => {
    if (is2pcsDesign()) {
      bar.querySelectorAll('.kaching-flex-break').forEach((el) => el.remove());
      return;
    }

    if (MOBILE_MQ.matches) return;

    const pricing = bar.querySelector(PRICING_SELECTOR);
    if (!pricing) return;

    const label = pricing.querySelector(LABEL_SELECTOR);
    if (!label) return;

    let br = pricing.querySelector('.kaching-flex-break');
    if (!br) {
      br = document.createElement('span');
      br.className = 'kaching-flex-break';
      br.setAttribute('aria-hidden', 'true');
    }

    if (br.nextElementSibling !== label) pricing.insertBefore(br, label);
  };

  const ensureSaleGroup = (priceContainer) => {
    if (!priceContainer) return null;

    const priceEl = priceContainer.querySelector('.price');
    if (!priceEl) return null;

    const group = priceEl.closest('span[role="group"]');
    if (group) return priceEl;

    const wrap = document.createElement('span');
    wrap.setAttribute('role', 'group');

    const vh = document.createElement('span');
    vh.className = 'visually-hidden';
    vh.innerHTML = 'Sale price&nbsp;';

    priceEl.parentNode.insertBefore(wrap, priceEl);
    wrap.appendChild(vh);
    wrap.appendChild(priceEl);

    return priceEl;
  };

  const ensureCompareGroup = (priceContainer) => {
    if (!priceContainer) return null;

    let compareEl = priceContainer.querySelector('.compare-at-price');
    if (compareEl) return compareEl;

    const wrap = document.createElement('span');
    wrap.setAttribute('role', 'group');

    const vh = document.createElement('span');
    vh.className = 'visually-hidden';
    vh.innerHTML = 'Regular price&nbsp;';

    compareEl = document.createElement('span');
    compareEl.className = 'compare-at-price';

    wrap.appendChild(vh);
    wrap.appendChild(compareEl);
    priceContainer.appendChild(wrap);

    return compareEl;
  };

  const syncBadge = (priceContainer, selectedBar) => {
    if (!priceContainer || !selectedBar) return;

    const srcLabel = selectedBar.querySelector(LABEL_SELECTOR);
    const existing = priceContainer.querySelector('[data-kaching-price-badge="1"]');

    if (!srcLabel) {
      if (existing) existing.remove();
      return;
    }

    const sig = (srcLabel.textContent || '').trim();

    if (!existing) {
      const clone = srcLabel.cloneNode(true);
      clone.setAttribute('data-kaching-price-badge', '1');
      clone.dataset.kachingSignature = sig;
      priceContainer.appendChild(clone);
      return;
    }

    if ((existing.dataset.kachingSignature || '') !== sig) {
      const clone = srcLabel.cloneNode(true);
      clone.setAttribute('data-kaching-price-badge', '1');
      clone.dataset.kachingSignature = sig;
      existing.replaceWith(clone);
    }
  };

  const parseMoney = (str) => {
    if (!str) return NaN;
    let s = String(str).replace(/[^\d.,-]/g, '').trim();
    if (s.includes(',') && s.includes('.')) s = s.replace(/,/g, '');
    if (s.includes(',') && !s.includes('.')) s = s.replace(/,/g, '.');
    const n = Number(s);
    return Number.isFinite(n) ? n : NaN;
  };

  const computeDiscountPercent = (priceText, compareText) => {
    const price = parseMoney(priceText);
    const compare = parseMoney(compareText);
    if (!Number.isFinite(price) || !Number.isFinite(compare)) return null;
    if (compare <= 0 || price >= compare) return null;
    return Math.round(((compare - price) / compare) * 100);
  };

  const syncDiscountAfterLabel = (bar) => {
    if (!bar) return;

    const label = bar.querySelector(LABEL_SELECTOR);
    if (!label) return;

    const priceEl = bar.querySelector(SRC_PRICE_SELECTOR);
    const compareEl = bar.querySelector(SRC_COMPARE_SELECTOR);

    const priceText = (priceEl?.textContent || '').trim();
    const compareText = (compareEl?.textContent || '').trim();

    const pct = computeDiscountPercent(priceText, compareText);

    const allBadges = bar.querySelectorAll(`[${DISCOUNT_BADGE_ATTR}]`);
    if (allBadges.length > 1) allBadges.forEach((b, i) => i && b.remove());

    let existing = bar.querySelector(`[${DISCOUNT_BADGE_ATTR}]`);

    if (pct === null) {
      if (existing) existing.remove();
      return;
    }

    const sig = `${pct}`;

    if (!existing) {
      existing = document.createElement('span');
      existing.className = 'kaching-off-badge';
      existing.setAttribute(DISCOUNT_BADGE_ATTR, '1');
      bar.appendChild(existing);
    }

    if ((existing.getAttribute(DISCOUNT_SIG_ATTR) || '') !== sig) {
      existing.textContent = `${pct}% OFF`;
      existing.setAttribute(DISCOUNT_SIG_ATTR, sig);
    }

    if (is2pcsDesign()) {
      const firstLine = bar.querySelector(FIRST_LINE_SELECTOR);
      if (firstLine && firstLine.lastElementChild !== existing) firstLine.appendChild(existing);
      return;
    }

    if (label.nextElementSibling !== existing) {
      label.insertAdjacentElement('afterend', existing);
    }
  };

  const replaceNumberInPrice = (priceText, divisor) => {
    const match = priceText.match(/\d[\d.,\s  ]*\d|\d/);
    if (!match) return '';

    const raw = match[0];
    const decimalMatch = raw.match(/[.,](\d{1,2})$/);
    const decimals = decimalMatch ? decimalMatch[1].length : 0;
    const decimalSep = decimalMatch ? raw.charAt(raw.length - decimals - 1) : '';
    const intRaw = decimalMatch ? raw.slice(0, raw.length - decimals - 1) : raw;
    const thousandsSep = (intRaw.match(/[.,\s  ]/) || [''])[0];

    const value = Number(intRaw.replace(/\D/g, '') + (decimals ? `.${decimalMatch[1]}` : ''));
    if (!Number.isFinite(value)) return '';

    const [intPart, fracPart] = (value / divisor).toFixed(decimals).split('.');
    const intOut = thousandsSep ? intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep) : intPart;
    const out = decimals ? `${intOut}${decimalSep}${fracPart}` : intOut;

    return priceText.slice(0, match.index) + out + priceText.slice(match.index + raw.length);
  };

  const relocateSubtitle = (bar) => {
    if (!bar || !is2pcsDesign()) return;

    const subtitle = bar.querySelector('.kaching-bundles__bar-subtitle');
    const main = bar.querySelector('.kaching-bundles__bar-main');
    if (!subtitle || !main) return;

    if (MOBILE_MQ.matches) {
      if (main.nextElementSibling !== subtitle) main.insertAdjacentElement('afterend', subtitle);
      return;
    }

    if (subtitle.parentElement !== main.parentElement) return;

    let secondLine = bar.querySelector('.kaching-bundles__bar-second-line');
    if (!secondLine) {
      const contentLeft = bar.querySelector('.kaching-bundles__bar-content-left');
      if (!contentLeft) return;
      secondLine = document.createElement('div');
      secondLine.className = 'kaching-bundles__bar-second-line';
      contentLeft.appendChild(secondLine);
    }
    secondLine.prepend(subtitle);
  };

  const ensureRadio = (bar) => {
    if (!bar || !is2pcsDesign()) return;

    const image = bar.querySelector('.kaching-bundles__bar-image');
    if (!image) return;

    let radio = bar.querySelector('.kaching-radio');
    if (!radio) {
      radio = document.createElement('span');
      radio.className = 'kaching-radio';
      radio.setAttribute('aria-hidden', 'true');
    }

    if (image.previousElementSibling !== radio) image.insertAdjacentElement('beforebegin', radio);
  };

  const syncPerSetPrice = (bar) => {
    if (!bar) return;

    const priceEl = bar.querySelector(SRC_PRICE_SELECTOR);
    const titleEl = bar.querySelector(TITLE_SELECTOR);
    const existing = bar.querySelector(`[${PER_SET_ATTR}]`);

    const count = parseInt(((titleEl?.textContent || '').match(/\d+/) || [])[0], 10);
    const template = document.body.dataset.kachingPerSetText || 'Only __PRICE__ / set';

    let text = '';
    if (is2pcsDesign() && priceEl && count > 1) {
      const perSet = replaceNumberInPrice((priceEl.textContent || '').trim(), count);
      if (perSet) text = template.replace('__PRICE__', () => perSet);
    }

    if (!text) {
      if (existing) existing.remove();
      return;
    }

    const el = existing || document.createElement('span');
    if (!existing) {
      el.className = 'kaching-per-set';
      el.setAttribute(PER_SET_ATTR, '1');
    }

    if (el.textContent !== text) el.textContent = text;
    if (priceEl.previousElementSibling !== el) priceEl.insertAdjacentElement('beforebegin', el);
  };

  const relocateLabelAndBadge = (bar) => {
    if (!bar) return;

    const contentLeft = bar.querySelector('.kaching-bundles__bar-content-left');
    let secondLine = bar.querySelector('.kaching-bundles__bar-second-line');

    if (!secondLine) {
      if (!MOBILE_MQ.matches || !contentLeft) return;
      secondLine = document.createElement('div');
      secondLine.className = 'kaching-bundles__bar-second-line';
      contentLeft.appendChild(secondLine);
    }

    const label = bar.querySelector(LABEL_SELECTOR);
    const badge = bar.querySelector('.kaching-off-badge');
    const desktopTarget = bar.querySelector(PRICING_SELECTOR);

    (is2pcsDesign() ? [label] : [label, badge]).forEach((el) => {
      if (!el) return;
      if (!_origParent.has(el)) _origParent.set(el, el.parentElement);

      if (MOBILE_MQ.matches) {
        if (el.parentElement !== secondLine) secondLine.appendChild(el);
      } else {
        const orig = _origParent.get(el);
        const restoreTo = orig && orig.isConnected ? orig : desktopTarget;
        if (restoreTo && el.parentElement !== restoreTo) restoreTo.appendChild(el);
      }
    });

    if (!MOBILE_MQ.matches && secondLine.childElementCount === 0) {
      secondLine.remove();
    }
  };

  const enforce = (root) => {
    if (!root) return;
    if (_busyRoots.has(root)) return;
    _busyRoots.add(root);

    try {
      const hasBundles = root.querySelector(BUNDLES_SELECTOR);
      if (hasBundles) {
        document.querySelectorAll(TEXTS_SELECTOR).forEach((el) => el.classList.add('show'));
      }

      const labels = root.querySelectorAll(LABEL_SELECTOR);
      if (labels.length) {
        labels.forEach((label) => {
          const bar = label.closest('.kaching-bundles__bar-container, .kaching-bundles__bar');
          if (!bar) return;

          const hasSecondLine = !!bar.querySelector('.kaching-bundles__bar-second-line');
          if (MOBILE_MQ.matches && hasSecondLine) return;

          const pricing = bar.querySelector(PRICING_SELECTOR);
          if (!pricing || pricing.contains(label)) return;

          pricing.appendChild(label);
        });
      }

      root.querySelectorAll('.kaching-bundles__bar, .kaching-bundles__bar-container').forEach((bar) => {
        ensurePricingBreak(bar);
        relocateSubtitle(bar);
        relocateLabelAndBadge(bar);
        syncDiscountAfterLabel(bar);
        syncPerSetPrice(bar);
        ensureRadio(bar);
      });

      const selectedBar = root.querySelector(SELECTED_BAR_SELECTOR);
      if (!selectedBar) return;

      const titleEl = selectedBar.querySelector(TITLE_SELECTOR);
      const titleText = (titleEl?.textContent || '').trim();

      if (titleText) {
        const block = document.querySelector(TARGET_BLOCK_SELECTOR);
        if (block) {
          let p = block.querySelector('p[data-kaching-title]');
          if (!p) {
            p = document.createElement('p');
            p.setAttribute('data-kaching-title', '1');
            block.appendChild(p);
          }
          if (p.textContent !== titleText) p.textContent = titleText;
        }
      }

      const srcPriceEl = selectedBar.querySelector(SRC_PRICE_SELECTOR);
      const srcCompareEl = selectedBar.querySelector(SRC_COMPARE_SELECTOR);

      const priceText = (srcPriceEl?.textContent || '').trim();
      const compareText = (srcCompareEl?.textContent || '').trim();

      const priceContainer = document.querySelector(PRICE_CONTAINER_SELECTOR);
      if (!priceContainer) return;

      const dstPriceEl = ensureSaleGroup(priceContainer);
      const dstCompareEl = ensureCompareGroup(priceContainer);

      if (dstPriceEl && priceText && dstPriceEl.dataset.kachingValue !== priceText) {
        dstPriceEl.textContent = priceText;
        dstPriceEl.dataset.kachingValue = priceText;
      }

      if (dstCompareEl) {
        if (compareText) {
          if (dstCompareEl.dataset.kachingValue !== compareText) {
            dstCompareEl.textContent = compareText;
            dstCompareEl.dataset.kachingValue = compareText;
          }
          const group = dstCompareEl.closest('span[role="group"]');
          if (group) {
            group.classList.remove('is-hidden', 'hidden');
            group.style.display = '';
          }
          dstCompareEl.classList.remove('is-hidden', 'hidden');
          dstCompareEl.style.display = '';
        } else {
          const group = dstCompareEl.closest('span[role="group"]');
          if (group) {
            group.classList.add('is-hidden');
            group.style.display = 'none';
          }
          dstCompareEl.classList.add('is-hidden');
          dstCompareEl.style.display = 'none';
          delete dstCompareEl.dataset.kachingValue;
        }
      }

      syncBadge(priceContainer, selectedBar);
    } finally {
      _busyRoots.delete(root);
    }
  };

  const waitForRoots = () => {
    const roots = document.querySelectorAll(ROOT_SELECTOR);
    if (!roots.length) {
      requestAnimationFrame(waitForRoots);
      return;
    }

    if (!window.__kachingBundlesMQBound) {
      window.__kachingBundlesMQBound = true;
      MOBILE_MQ.addEventListener('change', () => {
        document.querySelectorAll(ROOT_SELECTOR).forEach((root) => enforce(root));
      });
    }

    roots.forEach((root) => {
      let raf = 0;
      const run = () => {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => enforce(root));
      };

      run();

      const observer = new MutationObserver(run);
      observer.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    });
  };

  waitForRoots();
})();

/* Matsato osuren table scroll */
(function () {
  const SELECTOR = '.template-matsato-osuren .matsato-table';

  function createScrollbar(table) {
    if (!table || table.dataset.matsatoScrollbarInit === 'true') return;

    const scrollbar = document.createElement('div');
    scrollbar.className = 'matsato-scrollbar';

    const thumb = document.createElement('div');
    thumb.className = 'matsato-scrollbar__thumb';

    scrollbar.appendChild(thumb);
    table.insertAdjacentElement('afterend', scrollbar);

    table.dataset.matsatoScrollbarInit = 'true';

    function updateThumb() {
      const maxScroll = table.scrollWidth - table.clientWidth;

      if (maxScroll <= 0) {
        scrollbar.hidden = true;
        return;
      }

      scrollbar.hidden = false;

      const trackWidth = scrollbar.clientWidth;
      const thumbWidth = Math.max((table.clientWidth / table.scrollWidth) * trackWidth, 40);
      const maxLeft = trackWidth - thumbWidth;
      const left = (table.scrollLeft / maxScroll) * maxLeft;

      thumb.style.width = thumbWidth + 'px';
      thumb.style.left = left + 'px';
    }

    let isDragging = false;
    let startX = 0;
    let startLeft = 0;

    thumb.addEventListener('mousedown', function (e) {
      isDragging = true;
      startX = e.clientX;
      startLeft = table.scrollLeft;
      document.body.style.userSelect = 'none';
    });

    document.addEventListener('mousemove', function (e) {
      if (!isDragging) return;

      const dx = e.clientX - startX;
      const maxScroll = table.scrollWidth - table.clientWidth;
      const maxThumbMove = scrollbar.clientWidth - thumb.clientWidth;

      if (maxThumbMove <= 0) return;

      table.scrollLeft = startLeft + (dx / maxThumbMove) * maxScroll;
    });

    document.addEventListener('mouseup', function () {
      isDragging = false;
      document.body.style.userSelect = '';
    });

    scrollbar.addEventListener('click', function (e) {
      if (e.target !== scrollbar) return;

      const rect = scrollbar.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const thumbWidth = thumb.clientWidth;
      const maxThumbMove = scrollbar.clientWidth - thumbWidth;
      const targetLeft = Math.max(0, Math.min(clickX - thumbWidth / 2, maxThumbMove));
      const maxScroll = table.scrollWidth - table.clientWidth;

      table.scrollLeft = (targetLeft / maxThumbMove) * maxScroll;
    });

    table.addEventListener('scroll', updateThumb);
    window.addEventListener('resize', updateThumb);

    if (window.ResizeObserver) {
      const ro = new ResizeObserver(updateThumb);
      ro.observe(table);
      ro.observe(scrollbar);
    }

    requestAnimationFrame(updateThumb);
    setTimeout(updateThumb, 150);
    setTimeout(updateThumb, 500);
  }

  function initAll(root = document) {
    root.querySelectorAll(SELECTOR).forEach(createScrollbar);
  }

  function initWithRetry(root = document, tries = 12, delay = 250) {
    let count = 0;

    function run() {
      initAll(root);
      count += 1;
      if (count < tries && !root.querySelector(SELECTOR + '[data-matsato-scrollbar-init="true"]')) {
        setTimeout(run, delay);
      }
    }

    run();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initWithRetry(document);
  });

  window.addEventListener('load', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initWithRetry(event.target || document);
  });

  document.addEventListener('shopify:block:select', function (event) {
    initWithRetry(event.target || document);
  });
})();

/* Add domain to terms pages */
document.addEventListener('DOMContentLoaded', function () {
  const shopDomain = window.location.origin;

  const containers = [
    document.querySelector('.page-width-content'),
    document.querySelector('.shopify-policy__container')
  ].filter(Boolean);

  if (!containers.length) return;

  const replaceContent = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);

    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.includes('{domain}') || node.nodeValue.includes('derilashop.co.uk')) {
        node.nodeValue = node.nodeValue
          .replaceAll('{domain}', shopDomain)
          .replaceAll('https://derilashop.co.uk', shopDomain);
      }
    }

    root.querySelectorAll('*').forEach(el => {
      [...el.attributes].forEach(attr => {
        if (attr.value.includes('{domain}') || attr.value.includes('derilashop.co.uk')) {
          el.setAttribute(
            attr.name,
            attr.value
              .replaceAll('{domain}', shopDomain)
              .replaceAll('https://derilashop.co.uk', shopDomain)
          );
        }
      });
    });
  };

  containers.forEach(container => replaceContent(container));

  containers.forEach(container => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            replaceContent(node);
          }
        });
      });
    });

    observer.observe(container, { childList: true, subtree: true });
  });
});

/* Vacum template: move Kaching label + OFF badge after subtitle */
(() => {
  if (!document.body?.classList.contains('template-vacum')) return;

  const DESKTOP_MQ = window.matchMedia('(min-width: 750px)');

  const BAR_SELECTOR = '.kaching-bundles__bar, .kaching-bundles__bar-container';
  const SUBTITLE_SELECTOR = '.kaching-bundles__bar-subtitle';

  const LABEL_SELECTOR = '.kaching-bundles__bar-label:not([data-vacum-label-clone])';
  const BADGE_SELECTOR = '.kaching-off-badge:not([data-vacum-badge-clone])';

  const LABEL_CLONE_ATTR = 'data-vacum-label-clone';
  const BADGE_CLONE_ATTR = 'data-vacum-badge-clone';
  const SIG_ATTR = 'data-vacum-clone-sig';

  const LABEL_CLONE_CLASS = 'vacum-kaching-bar-label';
  const BADGE_CLONE_CLASS = 'vacum-kaching-off-badge';

  let isUpdating = false;
  let raf = 0;

  const text = (el) => (el?.textContent || '').trim();

  const makeSig = (label, badge) => {
    return `${text(label)}||${text(badge)}`;
  };

  const removeAllClones = () => {
    document
      .querySelectorAll(`[${LABEL_CLONE_ATTR}], [${BADGE_CLONE_ATTR}]`)
      .forEach((el) => el.remove());
  };

  const makeLabelClone = (label, sig) => {
    const clone = label.cloneNode(true);

    clone.removeAttribute('id');
    clone.removeAttribute('data-kaching-price-badge');
    clone.removeAttribute('data-kaching-signature');

    clone.classList.remove('kaching-bundles__bar-label');
    clone.classList.add(LABEL_CLONE_CLASS);

    clone.setAttribute(LABEL_CLONE_ATTR, '1');
    clone.setAttribute(SIG_ATTR, sig);
    clone.setAttribute('aria-hidden', 'true');

    return clone;
  };

  const makeBadgeClone = (badge, sig) => {
    const clone = badge.cloneNode(true);

    clone.removeAttribute('id');
    clone.removeAttribute('data-kaching-discount-badge');
    clone.removeAttribute('data-kaching-discount-sig');

    clone.classList.remove('kaching-off-badge');
    clone.classList.add(BADGE_CLONE_CLASS);

    clone.setAttribute(BADGE_CLONE_ATTR, '1');
    clone.setAttribute(SIG_ATTR, sig);
    clone.setAttribute('aria-hidden', 'true');

    return clone;
  };

  const syncBar = (bar) => {
    const subtitle = bar.querySelector(SUBTITLE_SELECTOR);
    if (!subtitle) return;

    const label = bar.querySelector(LABEL_SELECTOR);
    const badge = bar.querySelector(BADGE_SELECTOR);

    if (!label && !badge) return;

    const sig = makeSig(label, badge);

    let labelClone = bar.querySelector(`[${LABEL_CLONE_ATTR}]`);
    let badgeClone = bar.querySelector(`[${BADGE_CLONE_ATTR}]`);

    const oldSig =
      labelClone?.getAttribute(SIG_ATTR) ||
      badgeClone?.getAttribute(SIG_ATTR) ||
      '';

    const clonesAreInRightPlace =
      (!labelClone || subtitle.nextElementSibling === labelClone) &&
      (
        !badgeClone ||
        labelClone?.nextElementSibling === badgeClone ||
        subtitle.nextElementSibling === badgeClone
      );

    if (oldSig === sig && clonesAreInRightPlace) return;

    isUpdating = true;

    try {
      if (labelClone) labelClone.remove();
      if (badgeClone) badgeClone.remove();

      let insertAfter = subtitle;

      if (label) {
        labelClone = makeLabelClone(label, sig);
        insertAfter.insertAdjacentElement('afterend', labelClone);
        insertAfter = labelClone;
      }

      if (badge) {
        badgeClone = makeBadgeClone(badge, sig);
        insertAfter.insertAdjacentElement('afterend', badgeClone);
      }
    } finally {
      requestAnimationFrame(() => {
        isUpdating = false;
      });
    }
  };

  const syncAll = () => {
    if (!DESKTOP_MQ.matches) {
      removeAllClones();
      return;
    }

    document.querySelectorAll(BAR_SELECTOR).forEach(syncBar);
  };

  const schedule = () => {
    if (isUpdating) return;
    if (raf) cancelAnimationFrame(raf);

    raf = requestAnimationFrame(() => {
      raf = 0;
      syncAll();
    });
  };

  schedule();

  DESKTOP_MQ.addEventListener('change', schedule);

  const observer = new MutationObserver((mutations) => {
    if (isUpdating) return;

    const shouldRun = mutations.some((mutation) => {
      const target = mutation.target;

      if (!(target instanceof Element)) return true;

      if (
        target.hasAttribute?.(LABEL_CLONE_ATTR) ||
        target.hasAttribute?.(BADGE_CLONE_ATTR) ||
        target.closest?.(`[${LABEL_CLONE_ATTR}], [${BADGE_CLONE_ATTR}]`)
      ) {
        return false;
      }

      return true;
    });

    if (shouldRun) schedule();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['class', 'data-kaching-discount-sig']
  });
})();

/* Country select */
document.addEventListener('DOMContentLoaded', function () {
  const countrySelects = document.querySelectorAll('.custom-country-select');

  countrySelects.forEach(function (select) {
    const button = select.querySelector('.country-select-button');
    const dropdown = select.querySelector('.country-dropdown');
    const selectedText = select.querySelector('.selected-text');

    button.addEventListener('click', function (event) {
      event.stopPropagation();

      const isOpen = button.getAttribute('aria-expanded') === 'true';

      countrySelects.forEach(function (otherSelect) {
        const otherButton = otherSelect.querySelector('.country-select-button');
        const otherDropdown = otherSelect.querySelector('.country-dropdown');

        otherButton.setAttribute('aria-expanded', 'false');
        otherDropdown.style.display = 'none';
      });

      button.setAttribute('aria-expanded', String(!isOpen));
      dropdown.style.display = isOpen ? 'none' : 'block';
    });

    dropdown.querySelectorAll('.country-option').forEach(function (option) {
      option.addEventListener('click', function () {
        selectedText.textContent = option.textContent.trim();
        button.setAttribute('aria-expanded', 'false');
        dropdown.style.display = 'none';
      });
    });
  });

  document.addEventListener('click', function () {
    countrySelects.forEach(function (select) {
      const button = select.querySelector('.country-select-button');
      const dropdown = select.querySelector('.country-dropdown');

      button.setAttribute('aria-expanded', 'false');
      dropdown.style.display = 'none';
    });
  });
});

/* Hidden pages */
document.addEventListener('DOMContentLoaded', function () {
  const collectionParam = '-98394820';
  const productParam = '-984928103';
  const hiddenClass = 'hidden-page';
  const cookieName = 'hidden_page_session';
  const cookieDays = 2;

  const path = window.location.pathname;

  const triggeredNow =
    document.body.classList.contains(hiddenClass) ||
    path.includes(collectionParam) ||
    path.includes(productParam) ||
    path.includes('/pages/homepage') ||
    path.includes('/pages/quiz') ||
    path.includes('/products/matsato-knife-set');

  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()\[\]\\/+^])/g, '\\$1') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
  }

  if (triggeredNow) {
    setCookie(cookieName, '1', cookieDays);
  }

  const shouldRewrite = triggeredNow || getCookie(cookieName) === '1';

  if (!shouldRewrite) return;

  let isRewriting = false;

  function normalizeHost(host) {
    return host.replace(/^www\./, '');
  }

  function isSameStoreUrl(url) {
    return normalizeHost(url.hostname) === normalizeHost(window.location.hostname);
  }

  function rewriteUrl(value) {
    if (!value) return value;

    const trimmedValue = value.trim();

    if (
      trimmedValue.startsWith('#') ||
      trimmedValue.startsWith('mailto:') ||
      trimmedValue.startsWith('tel:') ||
      trimmedValue.startsWith('javascript:')
    ) {
      return value;
    }

    let url;

    try {
      url = new URL(trimmedValue, window.location.origin);
    } catch (error) {
      return value;
    }

    if (!isSameStoreUrl(url)) return value;

    const startedRelative = trimmedValue.startsWith('/') && !trimmedValue.startsWith('//');
    const startedProtocolRelative = trimmedValue.startsWith('//');

    let parts = url.pathname.split('/').filter(Boolean);

    if (parts.length === 1 && parts[0] === 'collections') {
      parts = ['collections', 'all'];
    }

    for (let i = 0; i < parts.length; i++) {
      if (parts[i] === 'collections' && parts[i + 1]) {
        if (!parts[i + 1].includes(collectionParam)) {
          parts[i + 1] = parts[i + 1] + collectionParam;
        }
      }

      if ((parts[i] === 'products' || parts[i] === 'product') && parts[i + 1]) {
        if (!parts[i + 1].includes(productParam)) {
          parts[i + 1] = parts[i + 1] + productParam;
        }
      }
    }

    url.pathname = '/' + parts.join('/');

    if (startedProtocolRelative) {
      return '//' + url.host + url.pathname + url.search + url.hash;
    }

    if (startedRelative) {
      return url.pathname + url.search + url.hash;
    }

    return url.href;
  }

  function rewriteElementAttribute(element, attributeName) {
    if (!element || !element.getAttribute) return;

    const oldValue = element.getAttribute(attributeName);
    const newValue = rewriteUrl(oldValue);

    if (newValue !== oldValue) {
      element.setAttribute(attributeName, newValue);
    }
  }

  function rewriteLink(link) {
    rewriteElementAttribute(link, 'href');
    rewriteElementAttribute(link, 'data-href');
    rewriteElementAttribute(link, 'data-url');
  }

  function updateHeaderLogo() {
    const logos = document.querySelectorAll(
      'a.header-logo, .header-logo a, .header__heading-link, a[href="/"], a[href="' + window.location.origin + '/"]'
    );

    logos.forEach(function (logo) {
      logo.setAttribute('href', '/pages/homepage');
    });
  }

  function updateLinks(scope) {
    if (!scope || !scope.querySelectorAll) return;

    const links = scope.querySelectorAll('a[href], a[data-href], a[data-url]');

    links.forEach(function (link) {
      rewriteLink(link);
    });
  }

  function updateShadowRoots(scope) {
    if (!scope || !scope.querySelectorAll) return;

    scope.querySelectorAll('*').forEach(function (element) {
      if (element.shadowRoot) {
        updateLinks(element.shadowRoot);
        updateShadowRoots(element.shadowRoot);
      }
    });
  }

  function updateAll() {
    if (isRewriting) return;

    isRewriting = true;

    updateHeaderLogo();
    updateLinks(document);
    updateShadowRoots(document);

    isRewriting = false;
  }

  updateAll();

  window.addEventListener('load', updateAll);
  window.addEventListener('resize', updateAll);

  document.addEventListener('mouseover', updateAll, true);
  document.addEventListener('focusin', updateAll, true);
  document.addEventListener('pointerdown', updateAll, true);
  document.addEventListener('click', function (event) {
    const link = event.target.closest && event.target.closest('a[href]');

    if (!link) return;

    const oldHref = link.getAttribute('href');
    rewriteLink(link);

    const newHref = link.getAttribute('href');

    if (newHref && newHref !== oldHref) {
      event.preventDefault();
      window.location.href = newHref;
    }
  }, true);

  setTimeout(updateAll, 100);
  setTimeout(updateAll, 300);
  setTimeout(updateAll, 750);
  setTimeout(updateAll, 1500);
  setTimeout(updateAll, 3000);
  setTimeout(updateAll, 5000);

  const interval = setInterval(updateAll, 500);

  setTimeout(function () {
    clearInterval(interval);
  }, 8000);

  const observer = new MutationObserver(function (mutations) {
    if (isRewriting) return;

    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes') {
        rewriteLink(mutation.target);
        return;
      }

      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        if (node.matches && node.matches('a')) {
          rewriteLink(node);
        }

        updateLinks(node);

        if (node.shadowRoot) {
          updateLinks(node.shadowRoot);
          updateShadowRoots(node.shadowRoot);
        }
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['href', 'data-href', 'data-url']
  });
});

/* Autoplay & loop product page gallery video */
(function () {
  function playVideo(video) {
    video.muted = true;
    video.loop = true;
    video.setAttribute('playsinline', '');
    const attemptPlay = () => video.play().catch(() => {});
    video.readyState >= 2 ? attemptPlay() : video.addEventListener('loadeddata', attemptPlay, { once: true });
  }

  function watchForVideo(deferredMedia) {
    const existingVideo = deferredMedia.querySelector('video');
    if (existingVideo) {
      playVideo(existingVideo);
      return;
    }

    const observer = new MutationObserver((mutations, obs) => {
      const video = deferredMedia.querySelector('video');
      if (video) {
        playVideo(video);
        obs.disconnect();
      }
    });
    observer.observe(deferredMedia, { childList: true, subtree: true });

    const loadButton = deferredMedia.querySelector('[ref="deferredMediaPlayButton"]');
    if (loadButton) loadButton.click();
  }

  function autoplayGalleryVideos(scope) {
    (scope || document).querySelectorAll('deferred-media').forEach((deferredMedia) => {
      if (deferredMedia.closest('zoom-dialog')) return;
      watchForVideo(deferredMedia);
    });
  }

  document.addEventListener('DOMContentLoaded', () => autoplayGalleryVideos());
  document.addEventListener('shopify:section:load', (e) => autoplayGalleryVideos(e.target));
})();

/* Free shipping amount & currency symbol by market — updates announcement bar & product page shipping USPs */
document.addEventListener("DOMContentLoaded", function () {
  const marketHandle = document.body.dataset.marketHandle;
  const map = document.body.dataset.freeShippingAmountMap;
  const currencySymbol = document.body.dataset.currencySymbol || "$";

  if (!marketHandle || !map) return;

  let amount = null;
  let fallback = null;

  map.split(",").forEach(pair => {
    const [handle, value] = pair.split(":").map(s => s.trim());
    if (handle === "default") fallback = value;
    if (handle === marketHandle) amount = value;
  });

  amount = amount || fallback;
  if (!amount) return;

  const targets = document.querySelectorAll(".announcement-bar__text, .product-shipping-usps");

  targets.forEach(el => {
    el.innerHTML = el.innerHTML.replace(/\$\d+(\.\d+)?/g, () => `${currencySymbol}${amount}`);
  });
});

/* Matsato BF gift card */
document.addEventListener("change", function (e) {
    const input = e.target.closest(".matsato-bf-gift__input");
    if (!input) return;

    const root = input.closest(".matsato-bf-gift");
    const variantId = root.querySelector('input[name="id"]');
    const label = root.querySelector(".add-to-cart-text__content");

    if (variantId) variantId.value = input.value;
    if (label) label.textContent = root.dataset.labelTemplate.replace("{price}", input.dataset.price);
});